<script>
/**
 * ****************************************************************************
 * @description     :   Popup Order008 (same search as MNG_Order008)
 * @created at      :   2026/02/09
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupOrder008Store from '@/views/popupSearch/PopupOrder008/store';
import PopupMST005Store from '@/views/popupSearch/PopupMST005/store';
import PopupSystem001Store from '@/views/popupSearch/PopupSystem001/store';
import helpers from '@/utils/helpers';
import '@/views/move/mng_order/MNG_Order008/style.scss';

var PopupOrder008Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupOrder008')) {
            store.registerModule('PopupOrder008', PopupOrder008Store);
        }
        if (!store.hasModule('PopupMST005')) {
            store.registerModule('PopupMST005', PopupMST005Store);
        }
        if (!store.hasModule('PopupSystem001')) {
            store.registerModule('PopupSystem001', PopupSystem001Store);
        }
    },
    async created() {
        this.onInitScreen();
        this.applyInitData();
        this.applyLoginCompanyFilter();
        if (this.data.department_cd) {
            await this.referAreaInfo(0, this.data.department_cd);
        }
        this.loadStatusOptions();

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const currentDate = now.toISOString().slice(0, 10).replace(/-/g, '/');
        const firstDayOfMonth = `${year}/${month}/01`;

        this.data.estimate_date_start = firstDayOfMonth;
        this.data.working_date_start = currentDate;

        this.search();
    },
    data() {
        return {
            rowActive: null,
            sort: {
                estimate_no: '',
                estimate_date: '',
                request_name: '',
                estimate_status: ''
            }
        };
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    watch: {
        'data.company_cd'(newVal, oldVal) {
            if (newVal == oldVal) return;
            this.data.department_cd = '';
            this.data.department_name = '';
            this.loadStatusOptions();
        }
    },
    computed: {
        ...mapState('app', ['user']),
        ...mapState('PopupOrder008', ['data', 'searchData', 'options', 'paginationData']),
        loginCompanyCd() {
            const companyCd = Number(this.user?.company_cd);
            return Number.isNaN(companyCd) ? null : companyCd;
        },
        isCompanyEditable() {
            return this.loginCompanyCd === null || this.loginCompanyCd === 99;
        },
        isCompanyInputDisabled() {
            const initCompanyCd = this.initData?.company_cd;
            const hasInitCompanyCd = initCompanyCd !== undefined && initCompanyCd !== null && String(initCompanyCd).trim() !== '';
            return hasInitCompanyCd || this.data.mode == 1;
        }
    },
    methods: {
        ...mapMutations('PopupOrder008', ['resetDataInit', 'setCombobox', 'setSearchData']),
        ...mapActions('PopupOrder008', ['actionSearch']),
        ...mapActions('PopupMST005', ['searchAreaInfo']),
        ...mapActions('PopupSystem001', ['searchSystemInfo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.mode !== undefined) {
                    this.data.mode = this.initData.mode;
                }
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
                if (this.initData.company_name !== undefined) {
                    this.data.company_name = this.initData.company_name;
                }
                if (this.initData.department_cd !== undefined) {
                    this.data.department_cd = this.initData.department_cd;
                }
                if (this.initData.department_name !== undefined) {
                    this.data.department_name = this.initData.department_name;
                }
            }
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        applyLoginCompanyFilter() {
            if (this.isCompanyEditable || this.loginCompanyCd === null) return;
            this.data.company_cd = this.loginCompanyCd;
            this.referCompany(null, this.loginCompanyCd);
        },
        search() {
            this.actionSearch({
                ...this.data,
                page_no: this.data.pageNo ?? this.paginationData.pageNo,
                page_size: this.data.pageSize ?? this.paginationData.pageSize,
                callback: () => {
                    this.rowActive = null;
                    this.applyLocalSort();
                }
            });
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.search();
        },
        referAreaInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (value) {
                    this.searchAreaInfo({
                        company_cd: this.data.company_cd ?? 0,
                        department_cd: value,
                        mode: 1,
                        callback: (response) => {
                            if (response.Data.data.length > 0) {
                                const result = response.Data.data[0];
                                this.data.department_cd = result.department_cd;
                                this.data.department_name = result.department_name;
                            } else {
                                this.data.department_cd = '';
                                this.data.department_name = '';
                            }
                            resolve();
                        },
                        onError: (error) => {
                            reject(error);
                        }
                    });
                } else {
                    this.data.department_cd = '';
                    this.data.department_name = '';
                    resolve();
                }
            });
        },
        referCompany(index, value) {
            if (value) {
                this.searchSystemInfo({
                    company_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.company_cd = result.company_cd;
                            this.data.company_name = result.company_name;
                        } else {
                            this.data.company_cd = '';
                            this.data.company_name = '';
                        }
                        this.data.department_cd = '';
                        this.data.department_name = '';
                    }
                });
            } else {
                this.data.company_cd = '';
                this.data.company_name = '';
                this.data.department_cd = '';
                this.data.department_name = '';
            }
        },
        getAreaName(data) {
            this.data.department_name = data;
        },
        getCompanyName(data) {
            this.data.company_name = data;
        },
        adjustDate(days, fieldName) {
            this.data[fieldName] = helpers.adjustDate(days, this.data[fieldName]);
        },
        initArrow(col, key) {
            this.sort = {
                estimate_no: '',
                estimate_date: '',
                request_name: '',
                estimate_status: ''
            };
            this.sort[col] = key;
        },
        sortCol(key, col) {
            this.initArrow(col, key);
            this.applyLocalSort();
        },
        applyLocalSort() {
            const activeCol = Object.keys(this.sort).find((key) => this.sort[key]);
            if (!activeCol) return;
            const direction = this.sort[activeCol];
            const numericCols = ['estimate_no', 'estimate_status'];
            const sorted = [...(this.searchData ?? [])].sort((a, b) => {
                let aValue = a?.[activeCol];
                let bValue = b?.[activeCol];
                if (numericCols.includes(activeCol)) {
                    aValue = Number(aValue ?? 0);
                    bValue = Number(bValue ?? 0);
                } else {
                    aValue = String(aValue ?? '');
                    bValue = String(bValue ?? '');
                }
                if (aValue === bValue) return 0;
                if (direction === 'asc') {
                    return aValue > bValue ? 1 : -1;
                }
                return aValue < bValue ? 1 : -1;
            });
            this.setSearchData(sorted);
        },
        chooseItem(item, index) {
            this.rowActive = index;
            this.$emit('onReferModelValue', item.estimate_no);
            this.$emit('onReferValueName', item.request_name ?? '');
            this.$emit('close');
        },
        async loadStatusOptions() {
            try {
                const companyCd = this.data.company_cd || this.loginCompanyCd || this.user?.company_cd || '';
                const result = await helpers.getDataSys005({ meisho_cd: 61, company_cd: companyCd });
                const statusOptions = (result || []).map((item) => ({
                    code: item.code ?? '',
                    name: item.name ?? ''
                }));
                this.setCombobox(statusOptions);
            } catch (e) {
                console.log('loadStatusOptions: ' + e.message);
                this.setCombobox([]);
            }
        }
    }
};
export default PopupOrder008Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
